// _guard/index.ts
export * from './auth.guard';


// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/_guard/index.ts